import { NavLink, useHistory } from "react-router-dom";
import { Tag } from "../../../modules/graphql/api.generated";
import { useFocusable } from "../../../modules/spatialNavigation";
import * as styles from "./styles.module.scss"; // Adjust the path as necessary

interface IProps {
  data: Tag;
  route: string;
}

const TagButton = (props: IProps) => {
  const history = useHistory();
  const { ref, focused } = useFocusable({
    onEnterPress: (e) => {
      history.push(props.route);
    },
  });

  return (
    <NavLink
      className={`${styles.tagChips} ${focused ? styles.focused : ""}`} // Apply focused class
      onClick={() => history.push(props.route)}
      ref={ref}
      to={props.route}
    >
      {props.data.name}
    </NavLink>
  );
};

export default TagButton;
